export const hasDatePassed = (date: Date) => date < new Date();
